import React from 'react'
import Button from './../../atoms/Button/Button'
import useTrans from '../../../hooks/useTrans'
import { Checkmark, Edit } from '../../atoms/NewIcons'

const StepItem = ({
  placeholder,
  open,
  children,
  stepNumber,
  Modificabile,
  setStep,
  recap,
  isDisabled,
}) => {
  const t = useTrans()
  const CheckMarkIcon = () => <Checkmark classes="personalizzazione__item__step__icon" />
  return (
    <div className="personalizzazione__item">
      <div
        className={`personalizzazione__item__container  ${isDisabled ? 'stepitem--disabled' : ''}`}
      >
        <div className="personalizzazione__item__wrapper">
          <div
            className={`personalizzazione__item__step ${
              isDisabled ? 'stepitem--bg--disabled' : ''
            }`}
          >
            {Modificabile ? <CheckMarkIcon /> : stepNumber}
          </div>
          <p className="personalizzazione__item__placeholder">
            {placeholder ? placeholder : 'Personalizzazione ITem'}
          </p>
        </div>
        {Modificabile && (
          <Button
            label={t('Modifica')}
            variant="ghost"
            size="medium"
            icon={<Edit />}
            icon_pos="left"
            className="personalizzazione__item__edit"
            onClick={() => setStep(stepNumber - 1)}
          />
        )}
      </div>
      {!open && Modificabile && <div className="personalizzazione__item__recap">{recap}</div>}
      {open && <div className="personalizzazione__item__children">{children}</div>}
    </div>
  )
}

export default StepItem
